import './Contact.styles.scss'
import { useTranslation } from 'react-i18next'

export default function Contact() {
    const { t, i18n } = useTranslation();
    
    return (
        <>
            <section id="contact" className="map_sec">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-10">
                            <div className="map_inner">
                                <h4>{t('contact.map.title')}</h4>
                                <p>{t('contact.map.description')}</p>
                                <div className="map_bind">
                                    <iframe
                                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3547.7438723131577!2d29.832986082332393!3d31.077295515533226!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14f5eba0874eb34d%3A0x3f3dfc1c17b4d34a!2z2YXYtdmG2Lkg2LnYqNivINin2YTZhdmG2LnZhSDYudio2K8g2KfZhNix2KTZiNmBINmE2YTYt9mI2Kgg2KfZhNin2LPZhdmG2KrZig!5e0!3m2!1sen!2seg!4v1749961340684!5m2!1sen!2seg"
                                        width="100%"
                                        height="450"
                                        frameBorder="0"
                                        style={{ border: '0' }}
                                        allowFullScreen
                                        aria-hidden="false"
                                        tabIndex="0"
                                        title={t('contact.map.location')}
                                    ></iframe>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
